export enum EStorageKey {
  TITLE = 'title',
  THEME = 'theme',
  TOKEN = 'token',
  USER_ID = 'user_id',
  BO_LOGIN_STATUS = 'BO_LOGIN_STATUS',
  LANGUAGE = 'language',
  PASSWORD = 'password',
  INDICATORS = 'indicators',
  THEME_SCHEME = 'theme_scheme',
  BALANCE_OPTIONS = 'balance_options',
  SEARCH_HISTORY = 'search_history',
  TRADING_ACCOUNT_IDENTITY = 'trading_account_identity',
  META_TRADER_GROUP = 'meta_trader_group',
  BIOMETRICS_ENABLE = 'biometrics_enable',
  TRADE_SUBSCRIPTION = 'trade_subscription',
  MARKET_SUBSCRIPTION = 'market_subscription',
  LOGIN_AS = 'LOGIN_AS',
  ASK_PRICE_VISIBLE = 'ASK_PRICE_VISIBLE',
  REMEMBER_ME = 'REMEMBER_ME',
  ACCOUNT_SWITCHED = 'ACCOUNT_SWITCHED',
  VOLUME_MODE_PREFERENCE = 'VOLUME_MODE_PREFERENCE',
  FCM_TOPICS = 'FCM_TOPICS',
  SHOULD_FETCH_FEATURE_ANNOUNCEMENTS_API = 'SHOULD_FETCH_FEATURE_ANNOUNCEMENTS_API', // To fetch feature announcements API once per login session , remove after fetching
  /**
   * To determine whether or not to Show All Symbols on Trade Page
   */
  SHOW_ALL_SYMBOLS = 'SHOW_ALL_SYMBOLS',
  DEEP_LINK_DATA = 'DEEP_LINK_DATA',
  ATTRIBUTION_DATA = 'ATTRIBUTION_DATA',
  IS_EAS_UPDATE_RELOAD = 'IS_EAS_UPDATE_RELOAD',
  MARKETING_PARAMS = 'MARKETING_PARAMS'
}

export interface IStorage {
  setItem: (key: EStorageKey, value: unknown) => void;
  getItem: <T = unknown>(key: EStorageKey) => T;
  removeItem: (key: EStorageKey) => void;
}
